import React from "react"
import { useTranslation } from "react-i18next"
import AdminPanelFormSection from "../../molecules/AdminPanelFormSection"
import ConnectionForm from "../../molecules/Forms/ConnectionForm"

interface Props {
	submitButton: JSX.Element,
}

const ConnectionFormSection = ({ submitButton }: Props) => {
	const { t } = useTranslation()

	return (
		<AdminPanelFormSection
			buttonsType="none"
			title={t("forms.header.connection")}
			tooltipText={t("forms.tooltip.connection")}
		>
			<ConnectionForm submitButton={submitButton} />
		</AdminPanelFormSection>
	)
}

export default ConnectionFormSection
